import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { showDrawer } from '../actions/app';
import AppBar from '../components/application-bar';
import { IState } from '../types';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class MainAppBar extends React.Component<IState | any, IState> {
  public render() {
    return (
      <div style={this.props.style}>
        <AppBar title={this.props.title} toggleDrawer={this.toogleDrawer}>
          {this.props.children}
        </AppBar>
      </div>
    );
  }

  private toogleDrawer = () => this.props.dispatch(showDrawer(!this.props.app.drawerOpen))
  
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(MainAppBar)));



// WEBPACK FOOTER //
// ./src/containers/main-appbar.tsx